import { Link } from "react-router-dom";

const isExternal = (href) => /^https?:\/\//i.test(href);

/* Internal paths route client-side; anything with a scheme is a plain anchor. */
export function SmartLink({ href, newTab = false, children, ...rest }) {
  if (isExternal(href)) {
    return (
      <a href={href} {...(newTab ? { target: "_blank", rel: "noopener noreferrer" } : {})} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link to={href} {...rest}>
      {children}
    </Link>
  );
}
